module.exports = __webpack_public_path__ + "img/service_images_bg_02.600b6f1e.png";